function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.2729 0H9.4547C9.05304 0 8.72741 0.325625 8.72741 0.727281C8.72741 1.12894 9.05304 1.45456 9.4547 1.45456H13.5171L6.03138 8.94031C5.74735 9.22434 5.74735 9.68478 6.03138 9.96881C6.17335 10.1108 6.35948 10.1818 6.5456 10.1818C6.73173 10.1818 6.91788 10.1108 7.05988 9.96878L14.5456 2.48306V6.54547C14.5456 6.94712 14.8713 7.27275 15.2729 7.27275C15.6746 7.27275 16.0002 6.94712 16.0002 6.54547V0.727281C16.0002 0.325625 15.6745 0 15.2729 0Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.3636 7.27274C11.962 7.27274 11.6363 7.59837 11.6363 8.00003V14.5455H1.45453V4.36365H8C8.40166 4.36365 8.72728 4.03802 8.72728 3.63637C8.72728 3.23471 8.40166 2.90912 8 2.90912H0.727281C0.325625 2.90912 0 3.23474 0 3.6364V15.2728C0 15.6744 0.325625 16 0.727281 16H12.3637C12.7653 16 13.0909 15.6744 13.0909 15.2727V8.00003C13.0909 7.59837 12.7653 7.27274 12.3636 7.27274Z",
  fill: "black"
});

function SvgExternalLink2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink2);
export default __webpack_public_path__ + "static/media/externalLink2.3329b0ef.svg";
export { ForwardRef as ReactComponent };